import React from "react";

const Social = () => {
  return (
    <div className="home_social w-16">
      <a
        href="https://www.linkedin.com/in/sakibsaizeed/"
        className="home_social-icon"
      >
        <i class="uil uil-linkedin"></i>
      </a>
      <a href="https://wa.me/+8801689279260" className="home_social-icon">
        <i class="uil uil-whatsapp"></i>
      </a>
      <a
        href="https://join.skype.com/invite/ywqXniwX4NV4"
        className="home_social-icon"
      >
        <i class="uil uil-skype"></i>
      </a>
    </div>
  );
};

export default Social;
